import React, { ChangeEvent } from 'react';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import useStyles from './FormTextField.styles';

interface Props {
  type: string
  name?: string
  label: string
  placeholder: string
  value: string
  helperText: any
  error: any
  handleChange?: (ev: ChangeEvent<HTMLInputElement>) => void;
}

const FormTextField: React.FC<Props> = (props) => {
  const classes = useStyles();
  const {
    name,
    type,
    label,
    placeholder,
    handleChange,
    helperText,
    error,
    value
  } = props;

  return (
    <FormControl className={classes.root}>
      <label className={classes.label}>{label}</label>
      <TextField
        name={name}
        type={type}
        variant="outlined"
        placeholder={placeholder}
        autoComplete="off"
        onChange={handleChange}
        size="medium"
        defaultValue={value}
        error={error}
        helperText={helperText}
      />
    </FormControl>
  );
};

export default FormTextField;
